var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 1516,
    viewBox: "0 0 630 1516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2232_471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-127.497 939.8C-27.0915 939.8 54.3032 858.405 54.3032 758H357.303C357.303 886.577 306.226 1009.89 215.309 1100.81C124.391 1191.72 1.08014 1242.8 -127.497 1242.8C-256.074 1242.8 -379.385 1191.72 -470.302 1100.81C-561.22 1009.89 -612.297 886.577 -612.297 758L-309.297 758C-309.297 858.405 -227.902 939.8 -127.497 939.8Z",
    fill: "url(#paint0_linear_2232_471)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.402 575.374C336.418 630.939 348.714 690.334 349.668 750.425H61.7294C57.7533 649.347 -25.4449 568.625 -127.497 568.625C-229.549 568.625 -312.747 649.347 -316.723 750.425L-604.662 750.425C-603.708 690.334 -591.411 630.939 -568.395 575.374C-544.412 517.474 -509.26 464.865 -464.946 420.551C-420.632 376.236 -368.023 341.084 -310.123 317.101C-252.223 293.119 -190.167 280.775 -127.497 280.775C-64.8268 280.775 -2.77039 293.118 55.1293 317.101C113.029 341.084 165.638 376.236 209.952 420.551C254.267 464.865 289.419 517.474 313.402 575.374Z",
    stroke: "url(#paint1_linear_2232_471)",
    strokeWidth: 15.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2232_471",
    x: -612.297,
    y: 712.55,
    width: 969.602,
    height: 560.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2232_471"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -45.45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2232_471",
    result: "effect2_innerShadow_2232_471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2232_471",
    x1: -127.497,
    y1: 1242.8,
    x2: -142.647,
    y2: 621.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A7B7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2232_471",
    x1: -165.372,
    y1: 273.2,
    x2: -165.372,
    y2: 856.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A7B7",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion3);
export default __webpack_public_path__ + "static/media/Union-3.66a59ec2153c1158040b89cc26b714dc.svg";
export { ForwardRef as ReactComponent };